export interface Duration {
  day: number;
  hour: number;
  minute: number;
}
